'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'floppy-disk';
var width = 448;
var height = 512;
var aliases = [128190,128426,"save"];
var unicode = 'f0c7';
var svgPathData = ['M32 64l64 0 0 144 224 0 0-144 96 96 0 288-384 0 0-384zM160 320a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z', 'M32 64l0 384 384 0 0-288-96-96 0 144-224 0 0-144-64 0zm96 0l0 112 160 0 0-112-160 0zM333.3 32l9.4 9.4 105.4 105.4 0 333.3-448 0 0-448 333.3 0zM224 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFloppyDisk = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;